import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable()
export class CatchErrorService implements ErrorHandler {
  private readonly _logger: LoggerService = inject(LoggerService);

  public handleError(error: unknown): void {
    this._logger.error(error);
  }
}
